// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__2zCVM","indicator":"Checkbox_indicator__R44sM"};